import React from "react";
import { ArrowUpRight, ChevronDown } from "lucide-react";
import { SITE, navTools } from "../data/mock";

const Navbar = () => {
  return (
    <header className="sticky top-0 z-50 w-full bg-white/80 backdrop-blur-md border-b border-black/5">
      <div className="max-w-[1280px] mx-auto flex items-center justify-between px-6 py-4">
        <a href="/" className="flex items-center gap-2">
          <img src={SITE.logo} alt={SITE.name} className="h-8 w-auto" />
          <span className="text-[20px] font-semibold tracking-tight text-black">{SITE.name}</span>
        </a>
        <nav className="hidden md:flex items-center gap-8 text-[15px] text-neutral-800">
          <div className="relative group">
            <button className="flex items-center gap-1 hover:text-black transition-colors py-2">
              Tools <ChevronDown className="w-3.5 h-3.5" />
            </button>
            <div className="absolute left-0 top-full pt-2 opacity-0 invisible translate-y-1 group-hover:opacity-100 group-hover:visible group-hover:translate-y-0 transition-all duration-150">
              <div className="bg-white border border-black/10 rounded-2xl shadow-lg p-2 min-w-[220px]">
                {navTools.map((tool) => (
                  <a
                    key={tool.label}
                    href={tool.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block px-4 py-2.5 rounded-xl text-sm text-neutral-700 hover:bg-neutral-50 hover:text-black transition-colors"
                  >
                    {tool.label}
                  </a>
                ))}
              </div>
            </div>
          </div>
          <a href="/about" className="hover:text-black transition-colors">About</a>
          <a href="/success-stories" className="hover:text-black transition-colors">Success Story</a>
          <a href="/category/blogs" className="hover:text-black transition-colors">Blogs</a>
        </nav>
        <div className="relative inline-flex group">
          <div className="absolute -inset-1 rounded-xl opacity-50 blur-md bg-gradient-to-r from-cyan-400 via-blue-500 to-fuchsia-500 transition-opacity duration-300 group-hover:opacity-80" />
          <a
            href="/connect"
            className="relative z-10 flex items-center gap-1.5 bg-black text-white px-4 py-2.5 rounded-xl text-sm font-medium transition-transform duration-200 group-hover:-translate-y-0.5"
          >
            Let's talk
            <ArrowUpRight className="w-4 h-4" />
          </a>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
